import { AgxBadge, AgxBadgeType } from '@urbanx/agx-ui-components';
import { MarketingPackageProjectionDisplayStatus } from '@urbanx/agx.marketing.client';

export const mapPaymentStatus = (
  status?: MarketingPackageProjectionDisplayStatus,
  small: boolean = false
) => {
  if (status === undefined || status === null) return <></>;

  switch (status) {
    case MarketingPackageProjectionDisplayStatus.Draft:
    case MarketingPackageProjectionDisplayStatus.AwaitingFunds:
      return (
        <AgxBadge
          small={small}
          text="Awaiting Funds"
          type={AgxBadgeType.Waiting}
        />
      );
    case MarketingPackageProjectionDisplayStatus.PayLaterApplicationSigned:
      return (
        <AgxBadge
          small={small}
          text="Pay Later Application Signed"
          type={AgxBadgeType.Action}
        />
      );
    case MarketingPackageProjectionDisplayStatus.Paid:
      return <AgxBadge small={small} text="Paid" type={AgxBadgeType.Success} />;
    case MarketingPackageProjectionDisplayStatus.Cancelled:
      return (
        <AgxBadge small={small} text="Cancelled" type={AgxBadgeType.Archived} />
      );
    case MarketingPackageProjectionDisplayStatus.PendingSettlement:
      return (
        <AgxBadge
          small={small}
          text="Pending Settlement"
          type={AgxBadgeType.Action}
        />
      );
    case MarketingPackageProjectionDisplayStatus.Complete:
      return (
        <AgxBadge small={small} text="Complete" type={AgxBadgeType.Action} />
      );
    case MarketingPackageProjectionDisplayStatus.Withdrawn:
      return (
        <AgxBadge small={small} text="Withdrawn" type={AgxBadgeType.Warning} />
      );
    case MarketingPackageProjectionDisplayStatus.PayLaterDeclined:
      return (
        <AgxBadge
          small={small}
          text="Pay Later Declined"
          type={AgxBadgeType.Warning}
        />
      );
    default:
      return <></>;
  }
};
